<template>
  <div class="student-info">
    <!-- 操作栏容器 -->
    <div class="student-info-operation-container">
      <!-- 搜索框 -->
      <div class="student-info-search-container">
        <search class="student-search" :placeholder="placeholder" @search="search" />
        <search class="student-search" :placeholder="studentNumberPlaceholder" @search="studentNumberSearch" />
        <!-- 选择班级 -->
        <div class="sensitiveWord-select-t">
          <el-cascader clearable v-model="className" :placeholder="classPlaceholder" :props="classProps"
            :options="classSelect" @change="changeHandle"></el-cascader>
        </div>
        <div class="sensitiveWord-select-t">
          <el-select v-model="searchStatus" placeholder="学生状态" clearable @change="statusChangeHandle">
            <el-option v-for="item in studentTypeList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="student-info-button-container">
        <!-- 新增学生 -->
        <button class="button add-student" @click="addStudentDialogShow" v-hasPermi="'sc:student:add'">
          新增学生
        </button>
        <!-- 批量导入 -->
        <button class="button download" @click="bulkImport">
          导入评定
        </button>
        <!-- 批量删除 -->
        <button class="button delete-student" @click="deleteClick" v-hasPermi="'sc:student:delete'">
          批量删除
        </button>
        <!-- 批量修改班级 -->
        <button class="button delete-student" @click="editClassClick">
          批量修改
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="student-info-table-container" v-bitmap="studentListGetResult">
      <studentList class="student-list" :studentData="studentData" @multipleDelete="multipleDelete"
        @studentSelect="studentSelect" :classProps="classProps" :classSelect="classSelect"
        :studentTypeList="studentTypeList" :classData="className" />
    </div>
    <!-- 分页容器 -->
    <div class="student-info-pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
    <!-- 添加学生的dialog -->
    <addStudentDialog :isAddStudentDialogShow.sync="isAddStudentDialogShow" :classData="className"
      :classProps="classProps" :classSelect="classSelect" v-show="isAddStudentDialogShow"
      @uploadFailList="uploadFailList" :studentTypeList="studentTypeList" />
    <!-- 上传失败信息的dialog -->
    <studentUploadFailList :isUploadFailShow.sync="isUploadFailShow" v-show="isUploadFailShow"
      :studentList="uploadFailStudent" />
    <!-- 批量修改学生班级dialog -->
    <switchClassDialog :dialogVisible.sync="editClassShow" v-show="editClassShow" :studentSelectList="studentSelectList"
      :classProps="classProps" :classSelect="classSelect" :classPlaceholder="classPlaceholder" :className="className"
      :studentTypeList="studentTypeList" @studentSwitchClass="studentSwitchClass" />
    <!-- 批量导入素质报告dialog -->
    <qualityReportUploadDialog :bulkImportDialogShow.sync="bulkImportDialogShow" :className="className" v-show="bulkImportDialogShow" />
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
import studentList from "./components/studentinfo-studentlist/studentInfo-studentList.vue";
import pagination from "@/components/pagination/pagination";
import upload from "@/components/upload/upload";
import Upload from "../../components/upload/upload.vue";
import addStudentDialog from "./components/studentinfo-addstudent-dialog/studentinfo-addstudent-dialog.vue";
import studentUploadFailList from "./components/student-upload-fail-list/student-upload-fail-list.vue";
import switchClassDialog from "./components//studentInfo-switch-class//studentInfo-switch-class.vue";
import qualityReportUploadDialog from "./components/quality-report-upload/qualityReportUpload.vue";
export default {
  data() {
    return {
      classData: {
        schoolId: "",
        schoolName: "",
        classId: "",
        className: "",
      },
      studentListGetResult: "nullData",
      isAddStudentDialogShow: false,
      placeholder: "输入姓名",
      studentNumberPlaceholder: "输入学号",
      studentData: [],
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      queryName: "",
      queryStudentNumber: "",
      deleteList: [], // 学生批量删除列表
      studentSelectList: [], // 学生选择列表
      uploadFailStudent: [],
      isUploadFailShow: false,
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "选择班级",
      editClassShow: false,
      studentTypeList: [],
      searchStatus: '',
      bulkImportDialogShow: false, // 批量导入弹窗显示
      // statusOptions: [{
      //   dictValue: '0',
      //   dictLabel: '在读'
      // },
      // {
      //   dictValue: '1',
      //   dictLabel: '结业'
      // }]
    };
  },
  provide() {
    return {
      refresh: this.refresh,
      standard: [
        {
          label: "姓名*",
          field: "studentName",
        },
        {
          label: "学号*",
          field: "studentNumber",
        },
        {
          label: "性别*",
          field: "sex",
        },
        {
          label: "家庭地址",
          field: "address",
        },
        {
          label: "班级职务",
          field: "duty",
        },
        {
          label: "政治面貌",
          field: "politicsStatus",
        },
      ],
    };
  },
  created() {
    // 获取年级班级
    this.selectSchoolAndGradeAndClassListPC();
    this.getStudentType();
  },
  mounted() { },
  components: {
    search,
    studentList,
    pagination,
    upload,
    Upload,
    addStudentDialog,
    studentUploadFailList,
    switchClassDialog,
    qualityReportUploadDialog
  },
  methods: {
    // 批量导入点击
    bulkImport() {
      if (this.classData.className == '') return this.$message.warning('请先选择班级');
      this.bulkImportDialogShow = true;
    },
    statusChangeHandle() {
      this.selectStudentListPC();
    },
    // 获取学生状态选择列表
    getStudentType() {
      this.get(`${this.$url.getDictType}/sc_student_type`).then((res) => {
        // console.log("获取学生状态选择列表==>", res);
        this.studentTypeList = res.data;
      });
    },
    studentSwitchClass(e) {
      let classData = e.classNameVal;
      let status = e.status;
      let data = {
        gradeId: classData[0].gradeId,
        gradeName: classData[0].gradeName,
        classId: classData[1].classId,
        className: classData[1].className,
        studentIds: this.deleteList,
        status,
      };
      this.post(this.$url.updateStudentClass, data).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.$message.success("修改成功");
          // 刷新列表
          this.refresh();
          // 关闭弹出框
          this.editClassShow = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeId, gradeName } = gItem;
              gItem.value = {
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classId, className } = cItem;
                cItem.value = {
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 默认选中时的classId/className
            // this.classData.classId =
            //   this.classSelect[0].schoolClassList[0].classId;
            // this.classData.className =
            //   this.classSelect[0].schoolClassList[0].className;
            // 获取学生列表
            this.selectStudentListPC();

            // 默认选中第一个年级班级
            // let firstGrade = {};
            // let { gradeId, gradeName } = this.classSelect[0];
            // firstGrade = { gradeId, gradeName };
            // let firstClass = {};
            // let { classId, className } = this.classSelect[0].schoolClassList[0];
            // firstClass = { classId, className };
            // this.className = [firstGrade, firstClass];
            // this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    // 选择班级
    changeHandle(e) {
      if (e.length) {
        this.classData.classId = e[1].classId;
        this.classData.className = e[1].className;
      } else {
        this.classData.classId = '';
        this.classData.className = '';
      }
      // console.log("选中的班级==>", e);
      // console.log("className", this.className);
      this.selectStudentListPC();
    },
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.studentData = [];
      // for (let key in this.classData) {
      //   this.classData[key] = "";
      // }
      // this.className = [];
      this.selectStudentListPC();
    },
    // 获取学生列表
    selectStudentListPC() {
      // console.log("1", this.classData);
      // console.log("2", this.classData.classId, this.classData.className);
      this.studentListGetResult = "loading";
      this.get(this.$url.selectStudentListPC, {
        schoolId: this.user.schoolId,
        schoolName: this.user.schoolName,
        classId: this.classData.classId,
        className: this.classData.className,
        studentName: this.queryName,
        studentNumber: this.queryStudentNumber,
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
        status: this.searchStatus
      })
        .then((res) => {
          // console.log("学生列表==>", res);
          if (res.code != 200) {
            this.studentListGetResult = "error";
            return this.$message.error(res.msg);
          }
          this.studentData = res.rows;
          this.total = res.total;
          this.total > 0
            ? (this.studentListGetResult = "success")
            : (this.studentListGetResult = "nullData");
          if (this.total === 0) {
            return (this.studentListGetResult = "nullData");
            // this.$message.warning("该班级暂未添加学生");
          }
          this.studentData.map((item) => {
            item.gradeClass = `${item.gradeName}${item.className}`;
          });
        })
        .catch((err) => {
          this.$message.error("获取学生信息列表失败，请稍后再试");
          this.studentListGetResult = "error";
          return;
        });
    },
    search(studentName) {
      this.queryName = studentName;
      // 刷新
      this.refresh();
    },
    studentNumberSearch(studentNumber) {
      this.queryStudentNumber = studentNumber;
      // 刷新
      this.refresh();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.selectStudentListPC();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.selectStudentListPC();
    },
    // 显示添加学生弹出框
    addStudentDialogShow() {
      if (this.classData.className == '') return this.$message.warning('请先选择班级');
      this.isAddStudentDialogShow = true;
    },
    multipleDelete(res) {
      // console.log(res);
      this.deleteList = res;
    },
    studentSelect(data) {
      this.studentSelectList = data;
    },
    // 批量修改班级
    editClassClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要修改班级的学生");
      }
      this.editClassShow = true;
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的学生");
      }
      this.$confirm("是否删除选中的学生?", "删除学生", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.post(this.$url.deleteStudentPC, this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    // 上传表格时有上传失败的工号或电话
    uploadFailList(option) {
      this.uploadFailStudent = option;
      this.isUploadFailShow = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./studentInfo.scss";
</style>
